import { queryClient } from '@moniebook-web/utils';
import { type QueryKey } from '@tanstack/react-query';

export function invalidateQuery(keys: Array<string | QueryKey>) {
    return Promise.all(
        keys.map((key) =>
            queryClient.invalidateQueries({
                queryKey: Array.isArray(key) ? key : [key],
            }),
        ),
    );
}
